<template>
  <div>
    <div class="form-group row">
      <label :for="this.id" class="col-12 col-lg-4 col-form-label">{{this.label}}</label>
      <div class="col-12 col-lg-8">
        <i class="fas fa-pound-sign currency-icon" aria-hidden="true" v-show="this.cssStyle !== ''"></i>
        <textarea rows="3" v-bind:class="[this.cssStyle]" class="form-control" :id="this.id" :name="this.id" v-model="defaultValue" @change="$emit('update', $event.target.id, $event.target.value)"></textarea> <!--  v-bind:disabled="isReadonly" -->
        <Tooltip v-show="this.showTooltip(this.tooltip, this.helpText)" :helpText="this.helpText" />
        <div class="bg-danger text-white col-12 clear-padding-left text-danger error-message" v-show="this.errors.hasKey(this.id)"><span class="" v-text="this.errors.getPropByKey('error', this.id)"></span></div>
      </div>
    </div>
  </div>
</template>

<script>

import Tooltip from "@/components/controls/Tooltip.vue";
import htmlControlsMixin from "@/mixins/htmlControls";
export default {
  name: "Textarea",
  props: ["helpText", "label", "id", "value", "errors", "tooltip", "css", "readonly"],
  mixins: [htmlControlsMixin],
  components: {
    Tooltip
  },
  data() {
    return {
      key: "value",
      cssStyle: typeof(this.css) !== 'undefined' ? this.css : "",
      isReadonly: typeof(this.readonly) !== 'undefined' && this.readonly == 'true' ? 'readonly'  : '',      
      defaultValue: ""
    };
  },
  methods: {},
  mounted() {
  },
  created () {
    this.defaultValue = this.value;
  },
};
</script>

<style scoped>

</style>